module.exports = __webpack_public_path__ + "img/PocketfulLogo.e4cc7cd9.jpeg";